import { appState } from '@/composable/appState';
import { i18n } from '@/plugin/vue-i18n';
import dayjs from 'dayjs';
import { MyAvailability } from './MyAvailability';
import { LEVEL_UP_AGENCY_IDS, LEVEL_UP_DATE } from './const';
// date format function
export const getFormattedDate = (time, format = 'MMM DD, YYYY hh:mm a') => {
    return dayjs(time).format(format);
};
// update chat widget settings
export const updateChatWidgetSetting = (key, val) => {
    const keys = key.split('.');
    let target = appState.chatWidgetSettingsData;
    for (let i = 0; i < keys.length - 1; i++) {
        if (!target[keys[i]]) {
            target[keys[i]] = {};
        }
        target = target[keys[i]];
    }
    target[keys[keys.length - 1]] = val;
    appState.unsavedChanges = true;
};
export const updateAdvanceSettings = (key, val) => {
    const keys = key.split('.');
    let target = appState.chatWidgetSettingsData.advanceSettings;
    for (let i = 0; i < keys.length - 1; i++) {
        if (!target[keys[i]]) {
            target[keys[i]] = {};
        }
        target = target[keys[i]];
    }
    target[keys[keys.length - 1]] = val;
    appState.unsavedChanges = true;
};
// time ago to show on builder header
export const timeAgo = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const diff = now.getTime() - date.getTime();
    const seconds = Math.floor(diff / 1000);
    const intervals = {
        years: 31536000,
        months: 2592000,
        days: 86400,
        hours: 3600,
        minutes: 60,
        seconds: 1,
    };
    let counter;
    for (const period in intervals) {
        counter = Math.floor(seconds / intervals[period]);
        if (counter > 0) {
            return i18n.global.t('builder.lastSaved1', {
                counter: `${counter}`,
                period: `${period}`,
            });
        }
    }
    return i18n.global.t('builder.lastSaved2');
};
// check if image url exists
// TODO: Find better way to handle prod links
export const isImageStorageUrl = (url) => {
    try {
        if (!!new URL(url).hostname)
            return true;
    }
    catch (err) {
        console.warn(err);
    }
    return false;
};
// normalize option for select
export const normalizeOption = (option) => {
    if (typeof option === 'string') {
        const cleanedOption = removeRandomNumber(option);
        let normalizedOption = appState.customFields.find((field) => field.value.toLowerCase() === cleanedOption.toLowerCase());
        if (normalizedOption) {
            return normalizedOption;
        }
        else {
            const customFieldsGroup = appState.customFields.find((field) => field.value === 'custom-fields');
            normalizedOption = customFieldsGroup
                ? customFieldsGroup.children.find((child) => removeRandomNumber(child.value.toLowerCase()) ===
                    cleanedOption.toLowerCase())
                : null;
            normalizedOption.value = removeRandomNumber(normalizedOption.value);
        }
        return {
            id: normalizedOption === null || normalizedOption === void 0 ? void 0 : normalizedOption.id,
            label: normalizedOption === null || normalizedOption === void 0 ? void 0 : normalizedOption.label,
            value: normalizedOption === null || normalizedOption === void 0 ? void 0 : normalizedOption.value,
            dataType: normalizedOption === null || normalizedOption === void 0 ? void 0 : normalizedOption.dataType,
            fieldKey: normalizedOption === null || normalizedOption === void 0 ? void 0 : normalizedOption.fieldKey,
            picklistOptions: normalizedOption === null || normalizedOption === void 0 ? void 0 : normalizedOption.picklistOptions,
        };
    }
    return option;
};
// ensure option for select
export const ensureOption = (options, id, value, label, dataType, fieldKey, placeholder) => {
    if (!options.some(option => option.value === value)) {
        options.push({ id, label, value, dataType, fieldKey, placeholder });
    }
};
// check if url is valid
export const isValidUrl = url => {
    const urlPattern = /^(https?:\/\/)?(www\.[a-zA-Z0-9-]+\.[a-zA-Z0-9-])*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}\/?([^\s]*)$/;
    return urlPattern.test(url);
};
export function getLocalizedDay(dayName, weekday) {
    var _a;
    const dayNumeric = (_a = MyAvailability.DAYS.find(day => day.name === dayName)) === null || _a === void 0 ? void 0 : _a.index;
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - currentDate.getDay() + dayNumeric);
    const options = { weekday: weekday || 'short' };
    return new Intl.DateTimeFormat(appState.locale, options).format(currentDate);
}
// generate random id
export const generateRandomNumber = () => {
    return Math.floor(1000000000 + Math.random() * 9000000000).toString();
};
// remove random id
export const removeRandomNumber = (str) => {
    return str.replace(/^\d{10}/, '');
};
// convert string to camel case
export const toCamelCase = (str) => {
    return str
        .toLowerCase()
        .replace(/([-_\s][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', '').replace(' ', ''))
        .replace(/\s+/g, '');
};
// check for level up agency ids
export const levelItemCheck = companyId => {
    if (process.env.NODE_ENV === 'production' && dayjs().isBefore(LEVEL_UP_DATE))
        return LEVEL_UP_AGENCY_IDS.includes(companyId);
    else
        return true;
};
// generate default open hours
export const generateDefaultOpenHours = (days) => {
    return days.map(day => ({
        daysOfTheWeek: [day],
        hours: [
            {
                openHour: '8',
                openMinute: '0',
                closeHour: '17',
                closeMinute: '0',
            },
        ],
    }));
};
